import { render } from "./SolicitudesGastoView.vue?vue&type=template&id=16aed68c"
import script from "./SolicitudesGastoView.vue?vue&type=script&lang=js"
export * from "./SolicitudesGastoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__